import React, { HTMLAttributes, useContext } from 'react'
import styled from 'styled-components'

import { AttributeSection, Skeleton } from '@syconium/little-miss-figgy'

import { VariantSelectionFormContext } from '../../../app/_components/forms/VariantSelectionForm'
import { useFeatureFlag } from '../../../app/_providers/ExperimentationProvider.client'
import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { EmbroiderySectionWrapper } from '../EmbroiderySectionWrapper'

import { EmbroideryLearnMoreModal } from './EmbroideryLearnMoreModal/EmbroideryLearnMoreModal'
import { EmbroideryPromoHeader } from './EmbroideryPromoHeader'

export type PersonalizeSectionWrapperProps = {
  children: React.ReactNode
  hasBorder?: boolean
}

export type PersonalizeSectionTextProps = {
  children: React.ReactNode
} & HTMLAttributes<HTMLDivElement>

const PersonalizeSectionWrapper = ({
  children,
  hasBorder = false,
}: PersonalizeSectionWrapperProps) => {
  const { embroidery: embroideryStrings } = useTranslation()

  const variantSelectionFormContext = useContext(VariantSelectionFormContext)!

  const learnMoreTrigger = <EmbroideryLearnMoreModal />

  const showNewEmbroideryTitle = useFeatureFlag<'true' | 'false'>({
    key: 'separate-pdp-embroidery-buttons',
    controlVariant: 'false',
    ifAccessedPriorToDecisionInitialization: 'return-null-while-pending',
    skip: !variantSelectionFormContext,
  })

  return (
    <EmbroiderySectionWrapper className='personalize-section' hasBorder={hasBorder}>
      {showNewEmbroideryTitle === null ? (
        <Skeleton key='EmbroideryCtaSkeleton' height='68px' animated />
      ) : (
        <AttributeSection
          title={
            <EmbroideryPromoHeader
              title={
                showNewEmbroideryTitle === 'true'
                  ? embroideryStrings.subtitle
                  : embroideryStrings.title
              }
            />
          }
          endAdornment={learnMoreTrigger}
        >
          {children}
        </AttributeSection>
      )}
    </EmbroiderySectionWrapper>
  )
}

const PersonalizeSectionText = ({ children, ...rest }: PersonalizeSectionTextProps) => {
  return (
    <MandatoryTextAndLogoEmbroideryWrapper {...rest}>
      {children}
    </MandatoryTextAndLogoEmbroideryWrapper>
  )
}

export const PersonalizeSection = {
  Wrapper: PersonalizeSectionWrapper,
  Text: PersonalizeSectionText,
}

const MandatoryTextAndLogoEmbroideryWrapper = styled.div`
  color: ${o => o.theme.color.deprecated.obsidianLight};
`
